<div class="w-full flex flex-col gap-6">
    <cdk-accordion class="flex flex-col gap-6">
        <cdk-accordion-item #drugDosageAccordion="cdkAccordionItem" [expanded]="true" class="mt-8">
            <div
                class="card bg-app-background-10 rounded-button shadow-sm border border-app-primary-10 overflow-hidden">
                <button
                    class="flex justify-between items-center w-full p-6 text-app-primary-10 font-bold text-xl hover:bg-gray-50 transition-colors"
                    (click)="drugDosageAccordion.toggle()" [attr.aria-expanded]="drugDosageAccordion.expanded">
                    <span>Dosierungen</span>
                    <i class="fa-solid self-center text-xl"
                       [ngClass]="drugDosageAccordion.expanded ? 'fa-angle-up' : 'fa-angle-down'"></i>
                </button>
                @if (drugDosageAccordion.expanded) {
                    <div class="p-6 pt-0 border-t border-app-primary-10/5 flex flex-col gap-4">
                        @for (drugDosage of drugDosages; track drugDosage; let i = $index) {
                            <div class="flex w-full gap-4">
                                <div class="form-group w-full">
                                    <div class="form-control">
                                        <input matInput [(ngModel)]="drugDosage.value" placeholder="Dosierung"
                                               #dosageInput="ngModel">
                                    </div>
                                </div>
                                @if (dosageInput.dirty) {
                                    <button
                                        class="bg-green-500/10 hover:bg-green-500 text-green-500 hover:text-white w-14 h-14 flex items-center justify-center rounded-button transition-all"
                                        (click)="saveDosageChanges(dosageInput.model, i, dosageInput)">
                                        <i class="fa-solid fa-save icon-center"></i>
                                    </button>
                                }
                                <button
                                    class="bg-red-500/10 hover:bg-red-500 text-red-500 hover:text-white w-14 h-14 flex items-center justify-center rounded-button transition-all">
                                    <i class="fa-solid fa-times icon-center"></i>
                                </button>
                            </div>
                        }
                        <div>
                            <div class="flex justify-end">
                                <button class="btn primary-button mt-4" (click)="addEmptyDosage()">
                                    <span>Dosierung hinzufügen</span>
                                </button>
                            </div>
                        </div>
                    </div>
                }
            </div>
        </cdk-accordion-item>

        <cdk-accordion-item #drugProcessingsAccordion="cdkAccordionItem">
            <div
                class="card bg-app-background-10 rounded-button shadow-sm border border-app-primary-10 overflow-hidden">
                <button
                    class="flex justify-between items-center w-full p-6 text-app-primary-10 font-bold text-xl hover:bg-gray-50 transition-colors"
                    (click)="drugProcessingsAccordion.toggle()"
                    [attr.aria-expanded]="drugProcessingsAccordion.expanded">
                    <span>Verarbeitungen</span>
                    <i class="fa-solid self-center text-xl"
                       [ngClass]="drugProcessingsAccordion.expanded ? 'fa-angle-up' : 'fa-angle-down'"></i>
                </button>
                @if (drugProcessingsAccordion.expanded) {
                    <div class="p-6 pt-0 border-t border-app-primary-10/5 flex flex-col gap-4">
                        @for (drugProcessing of drugProcessings; track drugProcessing; let i = $index) {
                            <div class="flex w-full gap-4">
                                <div class="form-group w-full">
                                    <div class="form-control">
                                        <input matInput [(ngModel)]="drugProcessing.value"
                                               placeholder="Verarbeitung" #processingInput="ngModel">
                                    </div>
                                </div>
                                @if (processingInput.dirty) {
                                    <button
                                        class="bg-green-500/10 hover:bg-green-500 text-green-500 hover:text-white w-14 h-14 flex items-center justify-center rounded-button transition-all"
                                            (click)="saveProcessingChanges(processingInput.model, i, processingInput)">
                                        <i class="fa-solid fa-save icon-center"></i>
                                    </button>
                                }
                                <button
                                    class="bg-red-500/10 hover:bg-red-500 text-red-500 hover:text-white w-14 h-14 flex items-center justify-center rounded-button transition-all"
                                        (click)="removeProcessing(drugProcessing.id, i)">
                                    <i class="fa-solid fa-times icon-center"></i>
                                </button>
                            </div>
                        }
                        <div class="flex justify-end">
                            <button class="btn primary-button mt-4" (click)="addEmptyProcessing()">
                                <span>Verarbeitung hinzufügen</span>
                            </button>
                        </div>
                    </div>
                }
            </div>
        </cdk-accordion-item>
    </cdk-accordion>
</div>
